import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureEmail
export interface IFeatureEmail extends IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_EMAIL_DEFAULT
export const _FEATURE_EMAIL_DEFAULT: Readonly<IFeatureEmail & Object> = {
  displayText: NavigationPageEnumHumanReadable.Email,
  feature: NavigationPageEnum.Email,
  ref: SettingsReferenceEnum.applicationEmailSettings,
  standalone: true,
};
//#endregion